var isObject = require('../internals/is-object');

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/a-possible-prototype.js
// module id = 1025
// module chunks = 0